// @flow
import React from 'react';
import ProfileBoardCardWithImpressions from 'app/common/react/components/profile/ProfileBoardCard/ProfileBoardCardWithImpressions';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Invite } from 'app/common/react/components/BoardCollab/types';
import type { ProfileBoardCardLayout } from 'app/common/react/components/profile/ProfileBoardCard/layout';
import type { ProfileBoardType } from 'app/common/react/components/profile/ProfileBoardCard/commonTypes';

type Props = {|
  invite: Invite,
  layout: 'list' | ProfileBoardCardLayout,
  onDeclineRequest: () => void,
  slotIndex: number,
|};

type State = {|
  board: ?ProfileBoardType,
|};

export class ProfileBoardInviteCardContainer extends React.Component<Props, State> {
  state = {
    board: null,
  };

  componentDidMount() {
    const { invite } = this.props;

    const options = { board_id: invite.board.id, field_set_key: 'profile_grid_item' };
    ResourceFactory.create('BoardResource', options)
      .callGet()
      .then((resource) => {
        this.setState({
          board: resource.resource_response.data,
        });
      });
  }

  render() {
    if (!this.state.board) {
      return null;
    }
    const { invite, layout, onDeclineRequest, slotIndex } = this.props;
    const { board } = this.state;
    const { image_cover_url, image_cover_hd_url } = board;

    const coverImageUrl = board.has_custom_cover ? image_cover_hd_url || image_cover_url : '';

    const coverImagePos = {
      height: 0,
      width: 0,
      x: board.has_custom_cover ? board.cover_pin.crop[0] : 0,
      y: board.has_custom_cover ? board.cover_pin.crop[1] : 0,
    };

    const images = (board || {}).images;
    const toastImageUrl = image_cover_url || image_cover_hd_url || '';

    return (
      <div
        style={{
          boxShadow: '0 0 0 2px #efefef',
          borderRadius: '8px',
        }}
      >
        <ProfileBoardCardWithImpressions
          board={board}
          canEdit={false}
          coverImagePos={coverImagePos}
          coverImageUrl={coverImageUrl}
          images={images}
          invite={invite}
          isOwnProfile={false}
          layout={layout}
          onDeclineRequest={onDeclineRequest}
          onEditClick={(event) => {}}
          progress={null}
          slotIndex={slotIndex}
          subtitle={null}
          toastImageUrl={toastImageUrl}
        />
      </div>
    );
  }
}

export default ProfileBoardInviteCardContainer;
